var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.54 6.498a2.878 2.878 0 00-.71-1.279 2.748 2.748 0 00-1.235-.742C18.875 4 12 4 12 4s-6.875 0-8.595.477a2.747 2.747 0 00-1.234.742A2.878 2.878 0 001.46 6.5C1 8.28 1 12 1 12s0 3.719.46 5.502c.124.483.37.924.71 1.279.342.354.768.61 1.235.742C5.125 20 12 20 12 20s6.875 0 8.595-.477a2.748 2.748 0 001.234-.742c.341-.355.587-.796.711-1.28C23 15.72 23 12 23 12s0-3.719-.46-5.502z",
    fill: "#FF0302"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 15.379V8.625l5.75 3.377-5.75 3.377z",
    fill: "#FEFEFE"
  })));
}
export default SvgYoutube;